import Panel from "./Panel";
import { shimmerWrapper } from "../Shimmer/Shimmer";

const wrappedPanel = shimmerWrapper(Panel);

export { wrappedPanel as Panel };
  
export default wrappedPanel;